export const ALL_FOR_COUNTRY = 'all-for-country';
export const HOTEL_ONLY = 'na';
